import { useParams } from "react-router-dom";
import { ScannerComponent } from "../../components/scanner/scanner.component";



export const ScanPage = () => {

  const { jobId, jobDocumentId } = useParams();
  return (
    <div className="h-full">
      <ScannerComponent jobId={jobId} jobDocumentId={jobDocumentId} />
    </div>
  );
};